import { apiClient } from './client';

export interface PartnerDocument {
  id: number; document_id: number; document_category: string; title: string; description: string | null;
  document_number: string | null; issue_date: string | null; expiry_date: string | null; issuing_authority: string | null;
  status: string; verified_by: number | null; verified_at: string | null; version: number; is_confidential: number;
  original_filename: string; mime_type: string; size_bytes: number; uploaded_by_name: string | null; created_at: string;
}

export const partnerDocumentsApi = {
  list: (partnerId: number) => apiClient.get<{ data: PartnerDocument[] }>(`/api/partners/${partnerId}/documents`),
  getVersionHistory: (id: number) => apiClient.get<{ data: PartnerDocument[] }>(`/api/partner-documents/${id}/history`),
  upload: (partnerId: number, input: Record<string, unknown>) => apiClient.post<{ data: { id: number } }>(`/api/partners/${partnerId}/documents`, input),
  replace: (id: number, input: Record<string, unknown>) => apiClient.post<{ data: { id: number; supersedes: number } }>(`/api/partner-documents/${id}/replace`, input),
  verify: (id: number) => apiClient.post<{ data: { id: number } }>(`/api/partner-documents/${id}/verify`),
  reject: (id: number, reason: string) => apiClient.post<{ data: { id: number } }>(`/api/partner-documents/${id}/reject`, { reason }),
  downloadUrl: (id: number) => `/api/partner-documents/${id}/download`,
};
